'use client';

import { ErrorPage } from '@/components';
import { PAGE_NOT_FOUND } from '@/constants/errorPageCopy';
import { useGlobalLoading } from '@/hooks';

// import { redirect, usePathname } from 'next/navigation';

export default function Custom404() {
  // Commenting out because OB v2 seems to have handled cookie setting
  // in the backend, but leaving in case that is no longer a valid solution
  // for any reason and we need to set the cookie in the frontend.

  // const pathname = usePathname();
  // if (pathname.includes('ref')) {
  //   const referralCode = pathname.split('/ref/')[1];
  //   redirect(`/?referralCode=${referralCode}`);
  // }
  useGlobalLoading(false);

  return <ErrorPage {...PAGE_NOT_FOUND} />;
}
